import { render, staticRenderFns } from "./SmallModal.vue?vue&type=template&id=64098336&scoped=true&"
import script from "./SmallModal.vue?vue&type=script&lang=js&"
export * from "./SmallModal.vue?vue&type=script&lang=js&"
import style0 from "./SmallModal.vue?vue&type=style&index=0&id=64098336&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64098336",
  null
  
)

export default component.exports